<template>
  <div
    v-if="showBannerMessage"
    :class="`widget_banner_tt banner ${bannerType}`"
  >
    <span v-html="bannerMessage"> </span>
  </div>
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  data() {
    return {
      showBannerMessage: false,
      bannerMessage: '',
      bannerType: 'error',
    };
  },
  mounted() {
    bus.$on(BUS_EVENTS.SHOW_ALERT, ({ message, type = 'error' }) => {
      this.bannerMessage = message;
      this.bannerType = type;
      this.showBannerMessage = true;
      setTimeout(() => {
        this.showBannerMessage = false;
      }, 3000);
    });
  },
};
</script>

<style lang="scss">
@import '~widget/assets/scss/variables.scss';
.widget_banner_tt.banner {
  color: $color-white;
  font-size: $font-size-default;
  font-weight: $font-weight-bold;
  padding: $space-slab;
  text-align: center;
  & a {
    text-decoration: underline;
  }
  &.success {
    background: $color-success;
  }
  &.error {
    background: $color-error;
  }
}
</style>
